// PWA 서비스워커 등록 — 차량 UI(안드로이드 태블릿)에서 설치/오프라인 셸을 위해 필요.
// 개발(dev/HMR) 중에는 캐시가 HMR을 방해하므로 프로덕션 빌드에서만 등록한다.
//
// 안전 업데이트 정책: skipWaiting() 제거 → 새 SW가 대기 중일 때 'sw-update-available'
// 이벤트를 window 에 디스패치해 UI 가 사용자에게 새로고침 안내를 할 수 있도록 한다.
// 제어 앱 특성상 세션 중 자동 교체는 금지한다.

function notifyUpdateAvailable(): void {
  console.info("[PWA] 새 버전 — 새로고침하면 업데이트됩니다.");
  window.dispatchEvent(new CustomEvent("sw-update-available"));
}

export function registerServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  if (!import.meta.env.PROD) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        // 이미 대기 중인 SW 가 있으면 즉시 알림 (새로고침 직후 감지)
        if (registration.waiting) {
          notifyUpdateAvailable();
        }

        // 새 SW 가 설치 중으로 진입하면 대기 상태 전환 시 알림
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && registration.waiting) {
              notifyUpdateAvailable();
            }
          });
        });
      })
      .catch((err) => {
        console.error("[PWA] service worker registration failed:", err);
      });
  });
}
